import { getApiClient } from '@/api/client';
import { getVehicle } from '@/api/generated/endpoints/vehicle/vehicle';
import { parseResponse } from '@/api/parseResponse';
import { VinDetail } from '@/api/schemas';

export async function getVinDetail(vin: string): Promise<VinDetail> {
  const response = await getVehicle(getApiClient()).getVinDetail(
    encodeURIComponent(vin),
  );
  return parseResponse(VinDetail, response.data, 'vehicle');
}
